/* eslint-disable @typescript-eslint/no-use-before-define */
// import template from "../../components/popup/template";
import { atomDefaultEvents, customEvents, pageDefaultEvents } from './actions.events';
import { listActionsByType } from './actions.actions';
import type {
  FlowActionDataEditor,
  TargetDataEditor,
  ActionDataEditor,
  SelectOption,
  RangeSliderOption,
  CheckboxOption,
} from './type';
import { svg } from '../utils/actions.assets';
// import { animations } from "./actions.animations.config";
// import { svgPreview } from "../utils/actions.assets";
//
/**
 * Actions template
 * @param atomLabel .
 * @returns string
 */
export default (atomLabel = ''): string => {
  return `
    <div class="md-body actions-panel">
      <div class="tabs">
        <div class="tab">
          <a href="#">Flow Actions</a>
          <div class="simple-tooltips">
            ${svg('info')}
            <span class="simple-tooltips-content">
              Click "+" to add an event to trigger action affect on other elements (e.g. move, change color, play video,…)
            </span>
          </div>
        </div>
        <div class="tab-action">
          <div class="tab-action-icon">
            ${svg('plus')}
          </div>
          <div class="list-event">
            ${selectTriggerEventsHtml(atomLabel)}
          </div>
        </div>
      </div>
      <div class="actions-body">
        <div class="actions-overlay"></div>
        <div class="actions-list">
          <div class="actions-empty">
            ${svg('emptyFlowActions')}
            <p class="actions-empty-text">
              Press "${svg('plus')}" button to add
              <br>
              new event trigger with
              <br>
              advanced action
            </p>
          </div>
        </div>
      </div>
    </div>
  `;
};

/**
 * Template for flow action item
 * @param flowActionItem ..
 * @returns string
 */
export const flowActionItemHtml = (flowActionItem: FlowActionDataEditor): string => {
  const checkboxValue = [];
  const screens = [
    {
      value: 'lg',
      text: 'Desktop',
    },
    {
      value: 'md',
      text: 'Laptop',
    },
    {
      value: 'sm',
      text: 'Tablet',
    },
    {
      value: 'xs',
      text: 'Mobile',
    },
  ];

  for (let i = 0; i < screens.length; i++) {
    if (flowActionItem.disableOn?.indexOf(screens[i].value) == -1) {
      checkboxValue.push(screens[i].value);
    }
  }

  let settingsHtml = '';
  if (flowActionItem.events[0].settings && flowActionItem.events[0].settings.length) {
    settingsHtml = getSettingsHtml(flowActionItem.events[0].settings, flowActionItem.events[0].data);
  }

  const checkboxs = checkboxesHtml('Trigger On', 'triggerOn', screens, checkboxValue);

  const html = `
  <div class="flow-item" data-action="">
    <div class="flow-head">
      <div class="flow-name">
        ${flowActionItem.events[0].name}
      </div>
      <div class="flow-description">
        <span class="des-show">${flowActionItem.events[0].description}</span>
        <span class="des-hide">${flowActionItem.events[0].description}</span>
      </div>
      <span class="delete-action">
        ${svg('delete')}
      </span>
      <span class="icon-arrow">
        ${svg('chevronDownBold')}
      </span>
    </div>
    <div class="flow-panel">
      <div class="flow-event-settings">
        ${settingsHtml}
      </div>
      <div class="flow-targets">
        <div class="flow-targets-head">
          Targets
          <span class="add-target icon">
          ${svg('plus')}
          </span>
        </div>
        <div class="select-targets">
        </div>
      </div>
      <div class="flow-trigger-on">
        ${checkboxs}
      </div>
    </div>
  </div>
  `;
  return html;
};

/**
 * Template for select event
 * @param atomLabel .
 * @returns string
 */
export const selectTriggerEventsHtml = (atomLabel = ''): string => {
  let atomDefaultHtml = '';
  for (let i = 0; i < atomDefaultEvents.length; i++) {
    atomDefaultHtml += `<option value="${atomDefaultEvents[i].key}" description="${atomDefaultEvents[i].description}">${atomDefaultEvents[i].name}</option>`;
  }

  const defaultEvents = pageDefaultEvents();

  let pageDefaultHtml = '';
  for (let i = 0; i < defaultEvents.length; i++) {
    pageDefaultHtml += `<option value="${defaultEvents[i].key}" description="${defaultEvents[i].description}">${defaultEvents[i].name}</option>`;
  }

  const cEvents = customEvents(atomLabel) || [];
  let customOptGroup = '';
  if (cEvents.length) {
    let customEventHtml = '';
    for (let i = 0; i < cEvents.length; i++) {
      customEventHtml += `<option value="${cEvents[i].key}" description="${cEvents[i].description}">${cEvents[i].name}</option>`;
    }
    if (customEventHtml) {
      customOptGroup = `<optgroup label="Custom event">${customEventHtml}</optgroup>`;
    }
  }

  return `<select name="event" description="Select a event">
    <optgroup label="Device input event">
      ${atomDefaultHtml}
    </optgroup>
    <optgroup label="Page event">
      ${pageDefaultHtml}
    </optgroup>
    ${customOptGroup}
  </select>`;
};

/**
 * Template for select event
 * @param target ..
 * @returns string
 */
export const targetItemHtml = (target: TargetDataEditor): string => {
  const labelText = target.rename ? target.rename : `${target.atomLabel}: ${target.id}`;
  return `<div class="target-wrap">
    <div class="target-label" data-type="${target.atomType}" data-target="${target.id}">
      <div class="target-label-text-wrap">
        <input class="target-label-text" value="${labelText}" disabled>
        <div class="wrap-icon">
          <span class="change-target icon">
            ${svg('changeTarget')}
          </span>
          <span class="expand icon">
            ${svg('expand')}
          </span>
          <div class="target-settings expand-list">
            ${selectTargetSettingsHtml()}
          </div>
        </div>
      </div>
      <div class="target-label-empty">
        - Select target -
      </div>
    </div>

    <div class="actions-wrap">
      <div class="target-actions">
      
      </div>
      <div class="target-add-new-wrap">
        <span class="target-add-new">
          ${svg('plus')} Add action
        </span>
        <div class="list-actions">
          ${listActionsHtml(target.atomLabel)}
        </div>
      </div>
    </div>
    
    
  </div>`;
};

/**
 * selectTargetSettingsHtml
 * @returns string
 */
export const selectTargetSettingsHtml = (): string => {
  //bỏ queue
  /* return `<ul name="more-settings">
    <li value="rename" data-icon="pen">Rename</li>
    <li value="duplicate" data-icon="dupilcate">Duplicate</li>
    <li value="queue" data-icon="queue">Queue Action <span class="turn-onoff">${svg("dot")}<span class="on">On</span><span class="off">Off</span></span></li>
    <li value="delete" data-icon="delete">Delete</li>
  </ul>`; */
  return `<ul name="more-settings">
    <li value="rename" data-icon="pen">Rename</li>
    <li value="duplicate" data-icon="dupilcate">Duplicate</li>
    <li value="delete" data-icon="delete">Delete</li>
  </ul>`;
};

/**
 * Template for select event
 * @param action ..
 * @returns string
 */
export const actionHtml = (action: ActionDataEditor): string => {
  return `<div class="target-action ${action.support === true ? '' : 'no-support'}">
    <div class="action-head">
      <div class="action-name" data-key="${action.key}">
        ${action.name}
      </div>
      <span class="icon-arrow">
        ${svg('chevronDownBold')}
      </span>
      <div class="wrap-icon">
        <div class="simple-tooltips tooltips-right warning icon">
          ${svg('warning')}
          <span class="simple-tooltips-content">
          This action is incompatible with current target
          </span>
        </div>
        <span class="expand icon">
          ${svg('expand')}
        </span>
      </div>
      <div class="action-more-settings expand-list">
        ${expandActionHtml()}
      </div>
    </div>
    <div class="action-settings">

    </div>
  </div>`;
};

/**
 * Template List Actions
 * @param atomLabel ..
 * @returns string
 */
export const listActionsHtml = (atomLabel?: string): string => {
  if (!atomLabel) {
    atomLabel = '';
  }

  const listActions = listActionsByType(atomLabel);

  let presetAnimationHtml = '';
  if (listActions.animations) {
    for (let i = 0; i < listActions.animations.length; i++) {
      presetAnimationHtml += `<option value="${listActions.animations[i].key}" description="${listActions.animations[i].description}">${listActions.animations[i].name}</option>`;
    }
  }

  let advancedHtml = '';
  if (listActions.actions) {
    for (let i = 0; i < listActions.actions.length; i++) {
      advancedHtml += `<option value="${listActions.actions[i].key}" description="${listActions.actions[i].description}">${listActions.actions[i].name}</option>`;
    }
  }

  return `<select name="action">
    <optgroup label="Preset animation">
      ${presetAnimationHtml}
    </optgroup>
    <optgroup label="Advanced">
      ${advancedHtml}
    </optgroup>
  </select>`;
};

/*export const selectTriggerEventsHtml = (): string => {

  let atomDefaultHtml = "";
  for (let i = 0; i < atomDefaultEvents.length; i++) {
    atomDefaultHtml += `<option value="${atomDefaultEvents[i].key}" description="${atomDefaultEvents[i].description}">${atomDefaultEvents[i].name}</option>`;
  }

  let pageDefaultHtml = "";
  for (let i = 0; i < pageDefaultEvents.length; i++) {
    pageDefaultHtml += `<option value="${pageDefaultEvents[i].key}" description="${pageDefaultEvents[i].description}">${pageDefaultEvents[i].name}</option>`;
  }

  const cEvents = customEvents() || [];
  let customOptGroup = "";
  if (cEvents.length) {
    let customEventHtml = "";
    for (let i = 0; i < cEvents.length; i++) {
      customEventHtml += `<option value="${cEvents[i].key}" description="${cEvents[i].description}">${cEvents[i].name}</option>`;
    }
    if (customEventHtml) {
      customOptGroup = `<optgroup label="Custom event">${customEventHtml}</optgroup>`;
    }
  }

  return `<select name="event" description="Select a event">
    <optgroup label="Device input event">
      ${atomDefaultHtml}
    </optgroup>
    <optgroup label="Page event">
      ${pageDefaultHtml}
    </optgroup>
    ${customOptGroup}
  </select>`;
};  */

/**
 * expandActionHtml
 * @returns string
 */
export const expandActionHtml = (): string => {
  return `<ul name="more-settings" class="expand-action">
    <li value="duplicate" data-icon="dupilcate">Duplicate</li>
    <li value="device-settings" data-icon="device">Devices setting</li>
    <li value="move-up" data-icon="moveUp">Move Up</li>
    <li value="move-down" data-icon="moveDown">Move Down</li>
    <li value="delete" data-icon="delete">Delete</li>
  </ul>`;
};

/* --------- setting action --------- */
/**
 * renderSelect
 * @param name .
 * @param key .
 * @param options .
 * @param value .
 * @returns string
 */
const selectHtml = (name: string, key: string, options: SelectOption[], value: string): string => {
  let optionsTemplate = '';
  for (let i = 0; i < options.length; i++) {
    optionsTemplate += `<option class="gf-dropdown-item" value="${options[i].value}" ${
      options[i].value == value ? 'selected' : ''
    }>${options[i].text}</option>`;
  }

  const templateBody = `
  <select name="${key}">
    ${optionsTemplate}
  </select>
  `;

  const template = `
      <div class="action-section">
        <p class="title">${name}</p>
        ${templateBody}
      </div>
    `;
  return template;
};

/**
 * Render Slider option
 * @param name .
 * @param key .
 * @param option .
 * @param value .
 * @returns string
 */
const rangeSliderHtml = (name: string, key: string, option: RangeSliderOption, value: string): string => {
  let template = '';
  template += `
    <div class="action-section">
      <p class="title">${name}</p>
      <input data-type="slider" name="${key}" data-name="${key}" data-min="${option.min}" data-max="${
    option.max
  }" data-step="${option.step || 1}" data-valuetype="${option.valueType}" value="${value}"/>
    </div>
  `;
  return template;
};

/**
 * Render Slider option
 * @param name .
 * @param key .
 * @param options .
 * @param values ..
 * @returns string
 */
const checkboxesHtml = (name: string, key: string, options: CheckboxOption[], values: string[]): string => {
  let template = '';
  let optionsTemplate = '';

  for (let i = 0; i < options.length; i++) {
    optionsTemplate += `<div class="checkbox-wrapper">
      <label>
        <input type="checkbox" data-type="checkbox" name="${key}" value="${options[i].value}" ${
      values.includes(options[i].value) ? 'checked' : ''
    }/>
        ${options[i].text}
      </label>
    </div>`;
  }
  template += `
    <div class="action-section">
      <p class="title">${name}</p>
      <div class="checkbox-group">
        ${optionsTemplate}
      </div>
    </div>
  `;
  return template;
};

/**
 * Render Button
 * @param name .
 * @param key .
 * @param icon .
 * @returns string
 */
const buttonHtml = (name: string, key: string, icon?: string): string => {
  let template = '';

  template += `
    <div class="action-section">
      <button type="button" class="action-button button-${key}" name="${key}">
        ${icon ? svg(icon) : ''}
        ${name}
      </button>
    </div>
  `;
  return template;
};

/**
 * Render Button
 * @param name .
 * @param key .
 * @returns string
 */
const buttonPreviewHtml = (name: string, key: string): string => {
  let template = '';

  template += `
    <div class="action-section">
      <button type="button" class="action-button button-${key}" name="${key}">
        <span class="icon-play">${svg('play')}</span>
        <span class="icon-pause">${svg('pause')}</span>
        ${name}
      </button>
    </div>
  `;
  return template;
};

/**
 * inputHtml
 * @param name .
 * @param key .
 * @param type .
 * @param value .
 * @returns string
 */
const inputHtml = (name: string, key: string, type: string, value: string): string => {
  if (!type) {
    type = 'text';
  }
  let template = '';

  template += `<div class="action-section">
    <p class="title">${name}</p>
    <input type="${type}" name="${key}" value="${value}"/>
  </div>`;
  return template;
};

/**
 * actionSettingsHtml
 * @param actionDataEditor ..
 * @returns string
 */
export const actionSettingsHtml = (actionDataEditor: ActionDataEditor): string => {
  let html = '';

  //screen settings not done
  html += `<ul class="screens">
    <li class="" data-screen="lg">${svg('screenLG')}</li>
    <li class="" data-screen="md">${svg('screenMD')}</li>
    <li class="" data-screen="sm">${svg('screenSM')}</li>
    <li class="" data-screen="xs">${svg('screenXS')}</li>
  </ul>`;

  //if type="animation" => select animation
  // if(actionDataEditor.type == 1){
  //   const animationOptions = animations.map((animation)=>{
  //     return {
  //       value: animation.key,
  //       text: animation.name
  //     };
  //   });
  //   html += selectHtml("Animation", "animation", animationOptions, actionDataEditor.key);
  // }

  html += getSettingsHtml(actionDataEditor.settings, actionDataEditor.data);
  return html;
};

/**
 * getSettingsHtml
 * @param settings .
 * @param data .
 * @returns string
 */
export const getSettingsHtml = (settings: any, data: any): string => {
  let html = '';
  for (let i = 0; i < settings.length; i++) {
    const setting = settings[i];
    const value = data && data[setting.key] != undefined ? data[setting.key] : setting.value;

    switch (setting.type) {
      case 'select':
        html += selectHtml(setting.name, setting.key, setting.options, value);
        break;
      case 'range':
        html += rangeSliderHtml(
          setting.name,
          setting.key,
          { min: setting.min, max: setting.max, step: setting.step, valueType: setting.valueType },
          value,
        );
        break;
      case 'checkbox':
        html += checkboxesHtml(setting.name, setting.key, setting.options, value);
        break;
      case 'text':
        html += inputHtml(setting.name, setting.key, 'text', value);
        break;
      case 'number':
        html += inputHtml(setting.name, setting.key, 'number', value);
        break;
      case 'button':
        if (setting.key == 'preview-animation') {
          html += buttonPreviewHtml(setting.name, setting.key);
        } else {
          html += buttonHtml(setting.name, setting.key, setting.icon);
        }

        break;
      default:
        break;
    }
  }

  return html;
};
